import { Outlet } from '@remix-run/react'
import DemoNavigation from '~/components/DemoNavigation'
const navigation = [
	{ name: 'Product', href: '#' },
	{ name: 'Features', href: '#' },
	{ name: 'Marketplace', href: '#' },
	{ name: 'Company', href: '#' },
]

export default function Index() {


	return (
		<div className="bg-white">
			{/* Header */}
			<header className="absolute inset-x-0 top-0 z-50">
				<DemoNavigation />
			</header>

			<main className="">
				<Outlet />
			</main>
			{/* Footer */}
			<footer className="mt-32 sm:mt-32">
				<div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
					<nav aria-label="Footer" className="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6">
						{navigation.map((item) => (
							<a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-900">
								{item.name}
							</a>
						))}
					</nav>
					<p className="mt-10 text-center text-sm/6 text-gray-600">
						&copy; 2024 Your Company, Inc. All rights reserved.
					</p>
				</div>
			</footer>
		</div>


	)
}
